import { router } from '@inertiajs/vue3';

export function useAtendimentoNavigation() {
    const getConsultaAtendimentoRoute = () => route('consulta-atendimento');
    const getAtendimentoRoute = (atendimentoId) => route('atendimento.page.show', { atendimentoId });

    const goToConsultaAtendimento = () => router.visit(getConsultaAtendimentoRoute());
    const showAtendimento = (atendimentoId) => router.visit(getAtendimentoRoute(atendimentoId));

    return {
        getConsultaAtendimentoRoute,
        getAtendimentoRoute,
        goToConsultaAtendimento,
        showAtendimento
    };
}
